import React from 'react';
import { MapPin, Phone, Mail, Clock, Star } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_c23aa9a6-13e0-48f7-b58f-0e02920451ab/artifacts/n1qvajmj_LOGO%20LES%20PLATANES.png"
                alt="Logo Les Platanes"
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">Les Platanes</h3>
                <div className="flex text-yellow-400 mt-1">
                  <Star className="h-3 w-3 fill-current" />
                  <Star className="h-3 w-3 fill-current" />
                </div>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Votre résidence de charme à 200m des thermes. 11 appartements entièrement équipés pour vos cures thermales et vacances.
            </p>
          </div>

          {/* Navigation rapide */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('accueil')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('emplacement')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Emplacement
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('appartements')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Nos Appartements
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('activites')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Activités
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('infos-pratiques')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Infos pratiques
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-emerald-400" />
                <span className="text-gray-300">+33 6 67 59 25 19</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-emerald-400" />
                <span className="text-gray-300">Rigaud.lesplatanes@gmail.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-emerald-400 mt-0.5" />
                <div className="text-gray-300">
                  <p>9 avenue du maréchal Joffre</p>
                  <p>34240 Lamalou-les-Bains, France</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Horaires d'accueil</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <Clock className="h-4 w-4 text-emerald-400" />
                <span>Réception 7j/7</span>
              </div>
              <div className="ml-6">
                <div className="flex justify-between">
                  <span>Lun - Ven:</span>
                  <span>8h00 - 20h00</span>
                </div>
                <div className="flex justify-between">
                  <span>Sam - Dim:</span>
                  <span>9h00 - 19h00</span>
                </div>
              </div>
            </div>

            <div className="mt-6 p-4 bg-gradient-to-r from-emerald-900/30 to-emerald-900/30 rounded-lg border border-emerald-800/30">
              <p className="text-sm text-emerald-300 font-medium">
                🌟🌟 Classement 2 étoiles
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Résidence certifiée pour l'accueil des curistes
              </p>
            </div>
          </div>
        </div>

        {/* Séparateur */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2024 Les Platanes. Tous droits réservés.
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-emerald-400 transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-emerald-400 transition-colors">Politique de confidentialité</a>
              <a href="#" className="hover:text-emerald-400 transition-colors">Conditions générales</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;